<template>
  <!-- <b-container class="p-0 m-0"> -->
    <apple-pay-button
      v-if="isCompatiable"
      style="width: 242px;"
      buttonstyle="black"
      type="plain"
      locale="en"
      @click="onApplePayButtonClicked"
    />
  <!-- </b-container> -->
</template>
  <script>
  const { VUE_APP_APPLE_PAY_API } = process.env
  import { createPaymentLog } from "../../modules/booking/services"
  export default {
    name: "ApplePay",
    props: {
      formData: Object,
      formValid: Boolean,
      isCompatiable: Boolean,
      paymentCost: String
    },
    data() {
      return {
        stats: [],
        pricingLine: {
          type: "final",
          label: "Payment Amount",
          amount: this.paymentCost
        },
        pricingTotal: {
          type: "final",
          label: "Trailfinders Ltd",
          amount: this.paymentCost
        },
        request: {
          countryCode:
          this.formData.bookno.charAt(0).toUpperCase() === "R"
              ? "IE"
              : "GB",
          currencyCode:
          this.formData.bookno.charAt(0).toUpperCase() === "R"
              ? "EUR"
              : "GBP",
          merchantCapabilities: ["supports3DS"],
          supportedNetworks: ["visa", "masterCard", "amex", "discover"],
          total: {
            type: "final",
            label: "Payment Amount",
            amount: this.paymentCost
          }
        }
      };
    },
    methods: {
      onApplePayButtonClicked() {
          const data = {
            name: `${this.formData.name} - ${this.formData.bookno}`,
            message: "Selected Pay With Apple Pay",
            content: this.formData,
            transId: 49973,
            error: false
          };
          // Save Initiation of Button click as a log.
          createPaymentLog(data);
    
          if (!window.ApplePaySession) {
            this.isCompatiable = false;
            return;
          }
          // Create ApplePaySession with (version Number, Request Object)
          this.request.total.amount = this.paymentCost
          this.pricingTotal.amount = this.paymentCost
          this.pricingLine.amount = this.paymentCost
          const session = new window.ApplePaySession(10, this.request);
    
          // Make a Request for Payment Request (Has to come from Registered Domain on Apple Account)
          session.onvalidatemerchant = event => {
            const axios = require("axios");
            const data = { appleUrl: event.validationURL };
    
            const options = {
              method: "post",
              url: `${VUE_APP_APPLE_PAY_API}/apple-pay/validate-merchant?source=${
                window.location.toString().indexOf("trailfinders.ie") > 0
                  ? "ie"
                  : "com"
              }`,
              headers: {
                json: true
              },
              data: data
            };
    
            return axios(options)
              .then(response => {
                if (!window.ApplePaySession) {
                  this.isCompatiable = false;
                  return;
                }
                const data = {
                  name: `${this.formData.name} - ${this.formData.bookno}`,
                  message: "Session Token Returned - Apple Pay",
                  content: this.formData,
                  transId: 49973,
                  error: false
                };
                // Save transaction to mongo where API will create a log.
                createPaymentLog(data);
                session.completeMerchantValidation(response.data);
              })
              .catch(async error => {
                const data = {
                  name: `${this.formData.name} - ${this.formData.bookno}`,
                  message: "Session Token Error - Apple Pay",
                  content: this.formData,
                  transId: 49973,
                  error: JSON.stringify(error)
                };
                // Save transaction to mongo where API will create a log.
                createPaymentLog(data);
              });
          };
    
          session.onpaymentmethodselected = () => {
            // Define ApplePayPaymentMethodUpdate based on the selected payment method. Parameters(newTotal, newLineItems) or dont change as we dont have shipping options
            session.completePaymentMethodSelection(this.pricingTotal, [
              this.pricingLine
            ]);
          };
    
          session.onpaymentauthorized = event => {
            this.formData.payType = "ApplePay";
            this.formData.sessionToken = JSON.stringify(event.payment.token);
            const data = {
              name: `${this.formData.name} - ${this.formData.bookno}`,
              message: "Payment Token Authorised - Apple Pay",
              content: this.formData,
              transId: 49973,
              error: false
            };
            //   Save transaction to mongo where API will create a log.
            createPaymentLog(data);
            //   Define ApplePayPaymentAuthorizationResult
            const result = {
              status: window.ApplePaySession.STATUS_SUCCESS
            };
            session.completePayment(result);
            this.$emit("on-submit", event.payment.token);
          };
    
          session.oncancel = () => {
            // Payment cancelled by WebKit
            const data = {
              name: `${this.formData.name} - ${this.formData.bookno}`,
              message: "Session Cancelled - Apple Pay",
              content: this.formData,
              transId: 49973,
              error: false
            };
            //   Save transaction to mongo where API will create a log.
            createPaymentLog(data);
            return;
          };
          session.begin();
        
      },
    }
  };
  </script>
  <style>
  apple-pay-button {
    --apple-pay-button-width: 242px;
    --apple-pay-button-height: 30px;
    --apple-pay-button-border-radius: 5px;
    --apple-pay-button-padding: 5px 0px;
  }
  apple-pay-button:hover {
    opacity: 0.75 
  }
  </style>
